import type { BlogPost } from '../types'

export const blogPosts: BlogPost[] = [
  {
    id: 'post-1',
    title: 'The Future of Web Design: AI-Driven Interfaces',
    slug: 'future-of-web-design-ai-interfaces',
    excerpt:
      'Explore how artificial intelligence is reshaping web design, from personalized user experiences to automated design systems that adapt in real-time.',
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    coverImage: '/images/blog-01.jpg',
    author: 'Alex Sterling',
    date: '2025-11-15',
    category: 'Design',
    tags: ['AI', 'Web Design', 'UX', 'Technology'],
    published: true,
  },
  {
    id: 'post-2',
    title: 'Performance Optimization Guide for React Apps',
    slug: 'performance-optimization-react-apps',
    excerpt:
      'Learn proven strategies to supercharge your React application performance, from code splitting to memoization and beyond.',
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    coverImage: '/images/blog-02.jpg',
    author: 'Maya Patel',
    date: '2025-10-20',
    category: 'Development',
    tags: ['React', 'Performance', 'JavaScript', 'Optimization'],
    published: true,
  },
  {
    id: 'post-3',
    title: 'SEO in 2026: What You Need to Know',
    slug: 'seo-2026-what-you-need-to-know',
    excerpt:
      'Stay ahead of the curve with the latest SEO trends, algorithm updates, and strategies that will define search rankings in 2026.',
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    coverImage: '/images/port-10.jpg',
    author: 'Sophie Laurent',
    date: '2025-09-05',
    category: 'SEO',
    tags: ['SEO', 'Marketing', 'Digital Strategy', 'Analytics'],
    published: true,
  },
]
